<div class="content overflow-y-auto p-(--space-1) scrollbar-thin flex flex-col gap-(--gap-relaxed) mb-(--space-4) w-full">
  <div class="flex flex-row gap-(--gap-relaxed)">
    <ces-text-field
      class="flex-1"
      [(ngModel)]="unit.name"
      (ngModelChange)="validateUniqueName(nameCtrl)"
      #nameCtrl="ngModel"
      name="name"
      [label]="'common.labels.name' | transloco"
      [required]="true"
      [minLength]="1"
      [maxLength]="30"
      [externalErrors]="getExternalErrors(nameCtrl)" />
    <ces-text-field
      class="flex-1"
      [(ngModel)]="unit.symbol"
      (ngModelChange)="validateUniqueName(symbolCtrl)"
      #symbolCtrl="ngModel"
      name="symbol"
      [label]="'common.labels.symbol' | transloco"
      [required]="true"
      [minLength]="1"
      [externalErrors]="getExternalErrors(symbolCtrl)" />
    <div class="flex flex-col gap-(--gap-normal) flex-1">
      <label>{{ 'common.labels.type' | transloco }}<sup>*</sup></label>
      <p-select
        [options]="unitTypes"
        optionLabel="name"
        optionValue="id"
        [placeholder]="'common.placeholders.select' | transloco"
        [(ngModel)]="unit.unitTypeId"
        name="unitType"
        #unitTypeCtrl="ngModel"
        required
        appendTo="body"
        [filter]="unitTypes.length >= 10"
        filterBy="name"
        [emptyFilterMessage]="'common.messages.noElementFound' | transloco"
        (onChange)="changeUnitType()"
        [disabled]="unitConversions.length > 0"
        [pTooltip]="unitConversions.length > 0 ? ('common.tooltips.unitTypeHasConversions' | transloco) : ''"
        tooltipPosition="top" />
      @if (unitTypeCtrl.invalid && (unitTypeCtrl.touched || unitTypeCtrl.dirty)) {
        <small class="text-red-500">
          @if (unitTypeCtrl.errors?.['required']) {
            <span>{{ 'validation.required' | transloco }}</span>
          }
        </small>
      }
    </div>
  </div>
  <div>
    <div class="flex items-center gap-(--gap-normal) mb-(--space-4)">
      <h2 class="font-medium">{{ 'common.labels.conversions' | transloco }}</h2>
      <button
        type="button"
        class="ces-help-button"
        (click)="conversionHelp.toggle($event)"
        [pTooltip]="'entities.unit.conversionHelp.tooltip' | transloco"
        tooltipPosition="right"
        [attr.aria-label]="'entities.unit.conversionHelp.tooltip' | transloco">
        <i class="pi pi-question-circle" aria-hidden="true"></i>
      </button>
    </div>
    <div>
      <ces-menu-button-secondary
        icon="add"
        [items]="unitItems"
        [label]="'forms.addConversion' | transloco"
        [disabled]="!unit.unitTypeId || unitItems.length === 0"
        [pTooltip]="
          !unit.unitTypeId
            ? ('common.tooltips.selectUnitTypeFirst' | transloco)
            : unitItems.length === 0
              ? ('common.tooltips.allConversionsConfigured' | transloco)
              : ''
        "
        tooltipPosition="top" />
    </div>
    @for (conversion of unitConversions; track conversion; let i = $index) {
      <div class="flex flex-row gap-(--gap-relaxed) mt-(--space-4) mb-(--space-4)">
        <div class="flex flex-col flex-1">
          <div class="flex items-center">
            <label class="text-sm font-normal">{{ conversion.srcSymbol }}</label>
            <ces-icon containerSize="sm">arrow_forward</ces-icon>
            <label class="text-sm font-normal">{{ conversion.tgtSymbol }}</label>
          </div>
          <input
            class="w-full"
            type="text"
            [(ngModel)]="conversion.expression"
            name="expression{{ i }}"
            [attr.aria-label]="conversion.srcSymbol + ' → ' + conversion.tgtSymbol"
            placeholder="(X * 1.8) + 32"
            pInputText />
          @if (conversion.expression && !isExpressionValid(conversion.expression)) {
            <small class="text-red-500">{{ 'validation.invalidConversionExpression' | transloco }}</small>
          }
        </div>
        <div class="flex flex-col flex-1">
          <div class="flex items-center">
            <label class="text-sm font-normal">{{ conversion.tgtSymbol }}</label>
            <ces-icon containerSize="sm">arrow_forward</ces-icon>
            <label class="text-sm font-normal">{{ conversion.srcSymbol }}</label>
          </div>
          <div class="flex items-center gap-(--gap-normal)">
            <input
              class="flex-1"
              type="text"
              [(ngModel)]="conversion.reverseExpression"
              name="reverseExpression{{ i }}"
              [attr.aria-label]="conversion.tgtSymbol + ' → ' + conversion.srcSymbol"
              placeholder="(X - 32) / 1.8"
              pInputText />
            <ces-delete-button (onClick)="deleteConversion(conversion)" />
          </div>
          @if (conversion.reverseExpression && !isExpressionValid(conversion.reverseExpression)) {
            <small class="text-red-500">{{ 'validation.invalidConversionExpression' | transloco }}</small>
          }
        </div>
      </div>
    }
  </div>
</div>

<p-popover #conversionHelp>
  <div class="max-w-md flex flex-col gap-(--gap-normal) text-sm">
    <p class="font-medium">{{ 'entities.unit.conversionHelp.intro' | transloco }}</p>
    <div>
      <p>{{ 'entities.unit.conversionHelp.factor' | transloco }}</p>
      <p class="text-muted-color text-xs">{{ 'entities.unit.conversionHelp.factorExample' | transloco }}</p>
    </div>
    <div>
      <p>{{ 'entities.unit.conversionHelp.expression' | transloco }}</p>
      <p class="text-muted-color text-xs">{{ 'entities.unit.conversionHelp.expressionExample' | transloco }}</p>
    </div>
  </div>
</p-popover>

<ces-dialog-footer
  [submitDisabled]="isFormInvalid()"
  [submitTooltip]="isFormInvalid() ? ('common.tooltips.formIncomplete' | transloco) : ''"
  (onSubmit)="validate()"
  (onCancel)="cancel()">
  @if (mode === 'edit') {
    <ces-delete-button
      footer-start
      (confirm)="delete()"
      [confirmationConfig]="unitDeleteConfig()"
      [disabled]="unit.isUsed"
      [label]="entityDefinition?.messages?.buttons?.delete?.() ?? '' | transloco"
      [pTooltip]="unit.isUsed ? ('common.errors.cannotDelete' | transloco) : ''"
      tooltipPosition="bottom" />
  }
</ces-dialog-footer>
